import TcListPageNoQuery from 'components/UI/TcListPage/TcListPageNoQuery';
import endpointUrls from 'global/Constants/endpointUrls';
import addressModel, { peopleAddress } from 'global/Models/addressModel';
import { IBackendSearchGeneric } from 'global/Models/globalModels';
import { handleApiThenGeneric } from 'global/helperFunctions/handleApiThen';
import ApiService from 'global/utils/ApiService';
import { FC, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

interface IOrderAddressesList {
  setAddress: (_address: peopleAddress) => void;
  peopleAddressTypeId: 1 | 2;
}

const OrderAddressesList: FC<IOrderAddressesList> = ({ setAddress, peopleAddressTypeId }) => {
  //states
  const [loading, setLoading] = useState<boolean>(false);
  const [list, setList] = useState<IBackendSearchGeneric<peopleAddress>>();
  const { userProfile } = useSelector((state: RootState) => state.user);

  //functions
  const getList = async (value: any) => {
    setLoading(true);
    await ApiService.post(endpointUrls.addressGetAll, { ...value, peopleAddressTypeId, creatorId: userProfile?.id })
      .then((res: IBackendSearchGeneric<peopleAddress>) => handleApiThenGeneric({ res, notifFail: false, notifSuccess: false, onSuccess: setList }))
      .catch(() => {});
    setLoading(false);
  };
  const columns = useMemo(
    () => [
      {
        title: 'عنوان',
        key: 'title',
        dataIndex: 'title',
        width: 150,
      },
      ...addressModel.columns(),
      {
        title: 'انتخاب',
        key: 'select',
        dataIndex: 'select',
        render: (_text: string, record: peopleAddress) => (
          <span
            className='cursor-pointer text-t-secondary-color hover:underline'
            onClick={() => {
              setAddress(record);
            }}>
            انتخاب
          </span>
        ),
      },
    ],
    []
  );

  return (
    <div>
      <TcListPageNoQuery
        columns={columns}
        getList={getList}
        loading={loading}
        list={list}
        filterItems={addressModel.filterItems}
        moreContent={<div className='pb-2 mb-2 border-b'>لیست</div>}
      />
    </div>
  );
};

export default OrderAddressesList;
